"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileDownload = getFileDownload;
exports.getWebGuaranteeQuery = getWebGuaranteeQuery;
var _request = _interopRequireDefault(require("@/utils/request"));
function getWebGuaranteeQuery(data) {
  return (0, _request.default)({
    url: '/ebusiness/webGuaranteeQuery/search',
    // url: '/webBlConsigneeCertification/add',
    method: 'post',
    data: data
  });
}
function getFileDownload(row) {
  return (0, _request.default)({
    responseType: 'blob',
    url: '/ebusiness/webGuaranteeQuery/download',
    method: 'post',
    data: row
  });
}